import { AuthService } from '../../shared/services/auth.service';
import { LastRouteService } from '../../shared/services/last-route.service';
import { StoreUser } from '../../workspace/user.abstract';
import { Component, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

@Component({
    selector: 'newgenus-logging-in',
    template: ` <div class="logout-wrapper">
        <div style="color: black;">Signing in...</div>
    </div>`,
    styleUrls: ['./logging-in.component.scss'],
    standalone: false,
})
export class LoggingInComponent extends StoreUser implements OnDestroy {
    private destroy$ = new Subject<void>();

    constructor(
        private auth: AuthService,
        private router: Router,
        store: Store,
        private lastRouteService: LastRouteService
    ) {
        super(store);
        this.initStoreUser(this.destroy$);

        console.log('[LOGGING-IN] Component initialized, subscribing to user$...');
        auth.user$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
            console.log(
                '[LOGGING-IN] user$ emitted:',
                user ? `uid=${user.uid}, preferences=${user.preferences !== undefined ? 'YES' : 'NO'}` : 'null'
            );
            setTimeout(async () => {
                // Just to display to the user...
                if (user && user.preferences !== undefined) {
                    // Pass the user's uid so getLastUrl can verify ownership
                    // and query Firestore even before startTracking fires
                    const lastUrl = await this.lastRouteService.getLastUrl(user.uid);
                    console.log('[LOGGING-IN] navigating to:', lastUrl || '/app/home');
                    if (lastUrl) {
                        this.router.navigateByUrl(lastUrl);
                    } else {
                        this.router.navigate(['/app/home']);
                    }
                } else {
                    console.log('[LOGGING-IN] user$ emitted but no preferences yet, waiting...');
                }
            }, 2500);
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.destroy$.unsubscribe();
    }
}
